module.exports = __webpack_public_path__ + "static/media/not_started_orange.a224bf43.svg";